export default __webpack_public_path__ + "static/media/yfi.da52d18e.svg";